<template>
  <div class="information-page">
    <div style="display:none">
      <img src="../../assets/img/default_thumbnail.jpg" style="width: 150px; height: 150px;" title="default_thumbnail" width="150" height="150" border="0" vspace="0" alt="default_thumbnail">
    </div>
    <HeaderCommon></HeaderCommon>
    <div class="pc-information-container">
      <div class="info-bg-header"></div>
      <div class="info-inner infor-detail-inner">
        <div class="crumbs">
          <i class="crumbs-icon"></i>
          <a href="/" v-text="$t('info.home')"></a>
          <i class="el-icon-arrow-right"></i>
          <a href="/info" v-text="$t('info.informations')"></a>
          <i class="el-icon-arrow-right"></i>
          <span v-text="$t('info.detail')"></span>
        </div>
        <div class="detail-content">
          <h1 class="detail-title" v-text="details.title"></h1>
          <div class="detail-meta">
            <span class="detail-date" v-text="details.publishTime"></span>
            <span class="detail-share">
              {{ $t('info.share')}}
              <el-popover placement="bottom" width="200" trigger="hover">
                <div id="qrCodeUrl" class="qrcode-img"></div>
                <div class="qrcode-text" v-text="$t('info.scan_qrcode')"></div>
                <i class="share-icon wechat-icon" :title="$t('info.share_wechat')" slot="reference"></i>
              </el-popover>
              <!-- <i class="share-icon yixin-icon" @click="ShareToYixin" :title="$t('info.share_yixin')"></i> -->
              <i class="share-icon sina-icon" @click="ShareToTsina" :title="$t('info.share_sina')"></i>
              <i
                class="share-icon qzone-icon"
                @click="shareToQzone"
                :title="$t('info.share_qzone')"
              ></i>
            </span>
            <span class="detail-hot" v-text="details.watchCount"></span>
          </div>
          <div class="detail-des" v-html="details.content"></div>
        </div>
      </div>
    </div>
    <div class="wap-info-detail">
      <div class="info-detail-container">
        <div class="info-detail-content" :style="{minHeight:contentHeight+'px',overflowY:'auto'}">
          <div class="crumbs">
            <i class="crumbs-icon"></i>
            <a href="/" v-text="$t('info.home')"></a>
            <i class="el-icon-arrow-right"></i>
            <a href="/info" v-text="$t('info.informations')"></a>
            <i class="el-icon-arrow-right"></i>
            <span v-text="$t('info.detail')"></span>
          </div>
          <div class="info-detail-title" v-text="details.title"></div>
          <div class="info-detail-meta">
            <div class="info-detail-date" v-text="details.publishTime"></div>
            <div class="info-detail-hot">
              <span class="hot-icon"></span>
              <span v-text="details.watchCount"></span>
            </div>
          </div>
          <div class="info-detail-des" v-html="details.content"></div>
        </div>
      </div>
    </div>
    <ScrollToTop></ScrollToTop>
    <FooterCommon></FooterCommon>
  </div>
</template>

<script>
import HeaderCommon from './template/HeaderCommon'
import FooterCommon from './template/FooterCommon'
import ScrollToTop from './template/ScrollToTop'
import { getUrlParam } from '../../assets/js/common'
import QRCode from 'qrcodejs2'
import { articlesDetail } from '../../request/api'
import wxSdk from '../../assets/js/util/sdk'

export default {
  data () {
    return {
      details: {},
      contentHeight: 0,
      default_thumbnail:''
    }
  },
  methods: {
    ShareToYixin () {
      window.open(
        'http://open.yixin.im/share?appkey=' +
        '&type=text' +
        '&text=' +
        this.details.title +
        '&url=' +
        encodeURIComponent(document.location.href) +
        '&title=' +
        this.details.title
      )
    },
    ShareToTsina () {
      window.open(
        'http://v.t.sina.com.cn/share/share.php?url=' +
        encodeURIComponent(document.location.href) +
        '&title=' +
        this.details.title
      )
    },
    shareToQzone () {
      window.open(
        'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' +
        encodeURIComponent(document.location.href) +
        '&title=' +
        this.details.title
      )
    },
    init () {
      this.calcuContentHeight()
      this.getDetail()
    },
    calcuContentHeight () {
      // 计算1rem的数值
      var vw = window.innerWidth / 100
      var windowHeight = window.innerHeight
      this.contentHeight = windowHeight - 55.5 * vw // 计算满屏的最小高度
    },
    getDetail () {
      var that = this
      var id = getUrlParam('no')
      articlesDetail({ id: id })
        .then(res => {
          if (res) {
            if (res.publishTime) {
              res.publishTime = res.publishTime.substring(0, 10)
            }
            that.details = res
            // eslint-disable-next-line no-undef
            $(document).attr('title', that.details.title)
            //设置qq浏览器自定义分享
            $("meta[itemprop='name']").attr('content', that.details.title)
            $("meta[itemprop='description']").attr('content', that.details.summary)
            $("meta[itemprop='image']").attr('content', that.details.thumbnail)
            that.shareToWX()
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    shareToWX () {
      let url = window.location.href.split('#')[0]
      let obj = {
        title: this.details.title, // 分享标题
        desc: this.details.summary,						// 分享内容
        linkurl: window.location.href, // 分享链接
        img: this.details.thumbnail||'https://cn-hangzhou-h-website-prod-1.obs.cn-east-3.myhuaweicloud.com/banner/2019-12-19/e7eb537cdb17d51571c391a8d790a5c6.png'			// 分享内容显示的图片
      }
      wxSdk.getJSSDK(url, obj)
    }
  },
  components: {
    HeaderCommon,
    FooterCommon,
    ScrollToTop
  },
  created () {},
  mounted () {
    // eslint-disable-next-line no-unused-vars
    var qrcode = new QRCode('qrCodeUrl', {
      text: document.location.href,
      width: 100,
      height: 100,
      colorDark: '#000000',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
    this.init()
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/pc";
@import "~@/assets/scss/wap";
</style>



// WEBPACK FOOTER //
// src/components/pc/InfoDetail.vue